<template>
  <div :title="i18n.title">
    <div v-if="second > 0" class="result-loading-warp">
      <div class="result-loading circle">
        <circle-progress v-model="percent" />
        <span>{{ secondFmt }}s</span>
      </div>
      <div class="result-loading-tips">
        {{ i18n.msg_tips_loading }}
      </div>
    </div>
    <div v-else-if="order" class="result-content">
      <!-- <img class="unlocked" src="../../assets/imgs/img_release.png" alt="" /> -->
      <h2>{{ i18n.title }}</h2>
      <div class="tips">{{ i18n.tips }}</div>
      <!-- <img class="mainbanner" :src="imgSrc" alt="" /> -->
      <img class="mainbanner" src="../../assets/imgs/rental_success.png" alt="" />
      <div class="downloadbtn btn" @click="onDownload">
        <span>{{ i18n.download }}</span>
      </div>
      <!-- 租借成功：返回地图首页 -->
      <div class="downloadbtn mapbtn btn" @click="goMap">
        <span>{{ i18n.btn_map }}</span>
      </div>
      <!-- <div class="downloadbtn" @click="goOrder"><span>{{ i18nMsg.vieworder }}</span></div> -->
    </div>
    <result-msg
      v-else-if="loading"
      type="100"
      :text="i18n.msg_result_loading"
    />
    <result-msg v-else-if="error" type="500" :text="error" @click="onReload" />
    <result-msg v-else />
  </div>
</template>

<script>
import { mapState } from "vuex"
import CircleProgress from "../../components/result/circle_progress.vue"
import ResultMsg from "../../components/result/msg.vue"
import { ORDER_CHECK, ORDER_TEMP } from "../../apis/cabinet.js"
import {
  PAYPAL_EXC_PAY,
  MYFATOORAH_PREAUTH_OF_CONFIRM,
  STRIPE_V2_RECHARGE,
  STRIPE_V2_SYNC,
  PAYSTACK_DVA_MANDATE_QUERY
} from "../../apis/payment.js"
let loadingTimer
export default {
  components: {
    ResultMsg,
    CircleProgress
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    paypal(val, oldVal) {
      if (val && val.paymentId) {
        this.onPayExec()
      }
    }
  },
  computed: {
    ...mapState(["cabinet", "system", "payType"]),
    i18n() {
      return this.$t("result")
    },
    i18nMsg() {
      return this.$t("msg")
    },
    percent() {
      return (this.second % 30) * 3.334
    },
    secondFmt() {
      return (this.second + 0.45).toFixed(0)
    },
    shopDesc() {
      return `${this.i18n.price_info}`.format(this.order)
    },
    infoTips1() {
      return `${this.i18n.tips_1}`.format(this.order)
    },
    infoTips2() {
      return this.i18n.tips_2
    },
    imgSrc() {
      if (this.order && this.order.shebei) {
        return `${process.env.VUE_APP_DOMAIN}/content/cabinet${this.order.shebei}_${this.order.number}.gif`
      } else {
        return `${process.env.VUE_APP_DOMAIN}/content/img_cabinet.png`
      }
    }
  },
  data() {
    return {
      loading: false,
      error: "",
      paypal: null,
      order: null,
      tradeNo: "",
      outTradeNo: "",
      second: 0,
      payMode: "paypal",
      downloadApp: false
    }
  },
  methods: {
    startTimer() {
      if (this.second === 0) {
        loadingTimer = setInterval(() => {
          this.second += 0.1
        }, 100)
      }
    },
    stopTimer() {
      clearInterval(loadingTimer)
      this.second = 0
    },
    onInput(val) {
      this.$emit("input", val)
    },
    onDownload() {
      let dowmloadUrl = process.env.VUE_APP_GOOGLE_PLAY
      if (this.system === "ios") {
        dowmloadUrl = process.env.VUE_APP_APP_STORE
      }
      if (dowmloadUrl) {
        window.open(dowmloadUrl)
      } else {
        this.$toast(this.i18nMsg.appoffline)
      }
    },
    // 租借成功页：返回地图首页
    goMap() {
      this.$router.replace("/map")
    },
    goOrder() {
      this.$router.replace("/order")
    },
    onReload() {
      const q = this.$route.query
      // DVA 已受理单（confirm 页直扣路径跳转后失败）：重轮询只会拿到同一 FAILED 终态，
      // 据 URL 的 dvaPaid=1 标记（而非 localStorage 会话残留）改走 _dvaStartPay 重新下单
      if (q.dvaPaid === '1' && this.outTradeNo) {
        this._dvaStartPay()
      } else if (this.outTradeNo) {
        this.onPayStackConfirm(this.outTradeNo)
      } else if (this.tradeNo) {
        this.checkOrder(this.tradeNo, this.payMode)
      } else if (
        q.payType === 'PayStack_DVA' ||
        q.dvaMandate === '1'
      ) {
        // mandate 回跳但尚无受理单号（下单请求本身失败）：重新发起 v2 DVA 下单，不走 PayPal excpay
        // 判据只认 URL 标记：曾用 !!localStorage.getItem("cdb_dva_pay_amount") 会把历史残留的
        // DVA 金额误判为本页待下单，向 PayStack 重复发起扣款
        this._dvaStartPay()
      } else {
        this.onPayExec()
      }
    },
    onPayExec() {
      this.startTimer()
      this.loading = true
      this.$post(
        PAYPAL_EXC_PAY,
        {
          ...this.paypal
        },
        (resp) => {
          this.loading = false
          this.error = ""
          const data = resp.data
          if (data.out_trade_no) {
            if (data.pay_type === "CZ") {
              this.$confirm({
                title: this.i18nMsg.title,
                content: this.i18nMsg.success_payment,
                confirmText: this.i18nMsg.confirm,
                showCancel: false
              }).then(() => {
                this.$router.push("/mine")
              })
            }
            if (data.pay_type === "YJ") {
              this.checkOrder(data.out_trade_no)
            }
          }
        },
        (error) => {
          if (this.second < 30) {
            this.onPayExec()
          } else {
            this.stopTimer()
            this.loading = false
            this.error = error
            console.log(error)
          }
        }
      )
    },
    checkOrder(tradeNo, payMode = "paypal", payType = "") {
      if (!payType) {
        this.startTimer()
      }
      // if (payMode === 'mpesa') {
      //   this.onSMSCheckOrder(tradeNo, payMode, payType)
      //   return
      // }
      this.tradeNo = tradeNo
      this.loading = true
      this.$post(
        `${ORDER_CHECK}/${tradeNo}/${payMode}`,
        {},
        (resp) => {
          if (payType === "FK") {
            this.$router.replace({ path: `/order` })
          } else if (payType === "CZ") {
            this.$router.replace({ path: "/wallet" })
          }
          // YJ 租借成功不再跳转：落入公共逻辑展示 Rental confirmed 成功页（原直接跳回首页地图）
          this.loading = false
          this.error = ""
          this.order = resp
          this.stopTimer()
        },
        (error) => {
          if (payType === "FK") {
            setTimeout(() => {
              this.$router.replace({ path: `/order` })
            }, 1500)
          } else if (payType === "CZ") {
            setTimeout(() => {
              this.$router.replace({ path: "/wallet" })
            }, 1500)
          } else if (error === "正在请求中" || error === "Processing") {
            setTimeout(() => {
              this.checkOrder(tradeNo, payMode, payType)
            }, 1000)
          } else {
            this.stopTimer()
            this.loading = false
            this.error = error
            console.log(error)
          }
        }
      )
    },
    // 订单支付确认
    onMyfatoorahConfirm(tradeNo = "", outTradeNo = "", type = "") {
      this.startTimer()
      this.loading = true
      const query = { tradeNo: tradeNo, outTradeNo: outTradeNo }
      this.$Request("get", MYFATOORAH_PREAUTH_OF_CONFIRM, query)
        .then((resp) => {
          const data = resp.data
          this.loading = false
          this.error = ""
          if (type === "RENT" && data && data.orderStatus === 1) {
            return this.$router.replace({ path: `/order` })
          } else if (data && data.orderStatus === 0) {
            return (this.error = resp.msg)
          }
          this.stopTimer()
          this.order = resp
        })
        .catch((error) => {
          console.warn("onMyfatoorahConfirm ~ error:", error)
          if (error === "正在请求中" || error === "Processing") {
            setTimeout(() => {
              this.onMyfatoorahConfirm(tradeNo, outTradeNo)
            }, 1000)
          } else {
            this.stopTimer()
            this.loading = false
            this.error = error
            console.log(error)
          }
        })
    },
    // PayStack 支付完成查证（v2 统一 sync）：SUCCESS 按 payType 分派；PROCESSING 轮询重查
    onPayStackConfirm (outTradeNo, retryCount = 0) {
      if (retryCount >= 30) {
        this.stopTimer()
        this.loading = false
        this.error = this.i18n.msg_pay_timeout
        return
      }
      this.startTimer()
      this.loading = true
      this.$getV2(
        `${STRIPE_V2_SYNC}?outTradeNo=${outTradeNo}`,
        {},
        (resp) => {
          console.log('this.payType', this.payType, resp)
          console.log('[DVA] sync 轮询:', outTradeNo, 'retryCount=', retryCount, 'resp=', resp)
          const status = resp.data && resp.data.status
          if (status === "SUCCESS") {
            // DVA 会话终结：清理会话标记、重试快照与待下单金额（本会话已无待办事项，不得残留至下一笔支付）
            localStorage.removeItem("cdb_dva_session")
            localStorage.removeItem("cdb_dva_retry_amount")
            localStorage.removeItem("cdb_dva_retry_type")
            localStorage.removeItem("cdb_dva_retry_order")
            localStorage.removeItem("cdb_dva_pay_amount")
            localStorage.removeItem("cdb_dva_pay_type")
            if (this.payType === "YJ") {
              // YJ 分支先停计时器，避免回背 cycle 中页面一直转圈
              this.stopTimer()
              this.loading = false
              this.error = ""
              setTimeout(() => {
                this.onBorrow()
              }, 2000)
            } else if (this.payType === "FK") {
              this.$router.replace({ path: `/order` })
              this.loading = false
              this.error = ""
              this.order = resp
              this.stopTimer()
            } else if (this.payType === "CZ") {
              this.$router.replace({ path: "/wallet" })
              this.loading = false
              this.error = ""
              this.order = resp
              this.stopTimer()
            } else {
              // 业务类型缺失（历史中断会话等）：支付已成功，停止转圈给出提示，避免无限 loading
              this.stopTimer()
              this.loading = false
              this.error = ""
              this.order = resp
              this.$toast(this.i18nMsg.success_payment)
            }
          } else if (status === "PROCESSING") {
            setTimeout(() => {
              this.onPayStackConfirm(outTradeNo, retryCount + 1)
            }, 1500)
          } else {
            this.stopTimer()
            this.loading = false
            this.error = (resp.data && resp.data.errorMsg) || this.i18n.msg_pay_failed
          }
        },
        (error) => {
          this.stopTimer()
          this.loading = false
          this.error = error
          console.log(error)
        }
      )
    },
    onBorrow() {
      // 三层兜底获取 cabinetID：store → route query → 独立 localStorage key
      const storedId = localStorage.getItem("cdb_borrow_cabinet_id") || ""
      const cabinetId =
        (this.cabinet && this.cabinet.cabinetID) ||
        this.$route.query.cabinetID ||
        storedId
      if (!cabinetId) {
        this.loading = false
        this.error = "Cabinet information not found, please retry from the cabinet"
        return
      }
      // 把充值单号作为租借订单号传入，建立确定性关联（充值列表 key 搜索可命中）
      const rechargeOrderId = this.outTradeNo || ""
      const url = `${ORDER_TEMP}?qrcode=${cabinetId}${rechargeOrderId ? '&orderId=' + rechargeOrderId : ''}`
      this.$get(
        url,
        {},
        (resp) => {
          console.log(resp)
          // 借用发起成功，清除临时存储
          localStorage.removeItem("cdb_borrow_cabinet_id")
          if (resp.data.outTradNo) {
            this.checkOrder(resp.data.outTradNo, 'PayStack', 'YJ')
          } else {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: this.i18n.msg_fail_content,
              showCancel: false
            })
          }
        },
        (error) => {
          console.log(error)
          // 押金不足等业务错误，弹窗提示后跳回首页重新操作
          this.stopTimer()
          this.loading = false
          this.$confirm({
            title: this.i18nMsg.title_fail,
            content: error,
            confirmText: this.i18nMsg.confirm,
            showCancel: false
          }).then(() => {
            this.$router.replace("/")
          })
        }
      )
    },
    // DVA mandate 授权回跳：轮询 GET /mandate 确认 ACTIVE 后再发起扣款。
    // PayStack webhook 可能有延迟，主动查询通道侧可即时感知授权完成。
    // 最多轮询 30 次（约 45 秒），超时后仍尝试发起扣款（后端 payOrderByDva 也有防御性查询）。
    _dvaPollMandate(retryCount = 0) {
      if (retryCount >= 30) {
        console.warn('[DVA] mandate 轮询超时，尝试发起扣款')
        this._dvaStartPay()
        return
      }
      if (retryCount === 0) {
        this.startTimer()
        this.loading = true
      }
      this.$getV2(
        PAYSTACK_DVA_MANDATE_QUERY,
        {},
        (resp) => {
          const status = resp.data && resp.data.status
          console.log('[DVA] mandate 轮询:', retryCount, 'status=', status)
          if (status === 'ACTIVE') {
            // mandate 已激活，发起扣款
            this._dvaStartPay()
          } else {
            // 未激活，继续轮询
            setTimeout(() => {
              this._dvaPollMandate(retryCount + 1)
            }, 1500)
          }
        },
        (error) => {
          console.warn('[DVA] mandate 轮询异常:', error)
          // 查询异常也继续轮询（不立即失败）
          setTimeout(() => {
            this._dvaPollMandate(retryCount + 1)
          }, 1500)
        }
      )
    },
    // DVA mandate 授权回跳：按业务类型发起 v2 统一下单（DVA 免密），成功后进入 PayStack sync 轮询。
    // 支付动作与 confirm 页直扣路径同源（STRIPE_V2_RECHARGE + dva），不再有独立 pay/order 链路。
    _dvaStartPay() {
      this.startTimer()
      this.loading = true
      const q = this.$route.query
      const isMandateReturn = q.dvaMandate === '1' || q.payType === 'PayStack_DVA'
      // URL 回传参数优先（后端 mandate 回调回显，不受移动端 localStorage 被清影响），localStorage 兜底
      const savedType = q.dvaType || localStorage.getItem("cdb_dva_pay_type") || localStorage.getItem("cdb_dva_retry_type") || "YJ"
      let savedAmount = q.dvaAmount || localStorage.getItem("cdb_dva_pay_amount") || ""
      let savedQrcode = q.dvaQrcode || localStorage.getItem("cdb_borrow_cabinet_id") || ""
      let outTradeNo = q.outTradeNo || ""
      console.log("[DVA] startPay 决策:", {
        isMandateReturn: isMandateReturn,
        outTradeNo: outTradeNo,
        savedType: savedType,
        savedAmount: savedAmount,
        query: {
          dvaAmount: q.dvaAmount,
          dvaType: q.dvaType,
          dvaQrcode: q.dvaQrcode,
          dvaMandate: q.dvaMandate
        },
        ls: {
          amount: localStorage.getItem("cdb_dva_pay_amount"),
          type: localStorage.getItem("cdb_dva_pay_type"),
          session: localStorage.getItem("cdb_dva_session"),
          retryAmount: localStorage.getItem("cdb_dva_retry_amount")
        }
      })
      // 重试分流（本页已受理单失败后由 onReload 再入）：URL 的 outTradeNo 是已失败的受理单号
      // （非业务订单号），不得重轮询、也不得误入订单模式，故重置后以重试金额重新 v2 下单；
      // 订单会话（retry_type=ORDER）例外：下单成功后 URL 已换成充值单号，业务订单号需从快照取回
      const isRetry = !isMandateReturn && (q.dvaPaid === '1' || localStorage.getItem("cdb_dva_session"))
      if (isRetry && localStorage.getItem("cdb_dva_retry_type") === "ORDER") {
        outTradeNo = localStorage.getItem("cdb_dva_retry_order") || ""
        if (!outTradeNo) {
          this.stopTimer()
          this.loading = false
          this.error = "Payment session expired, please retry from the cabinet"
          return
        }
      } else if (isRetry) {
        savedAmount = localStorage.getItem("cdb_dva_retry_amount") || savedAmount
        outTradeNo = ""
      }
      let datas
      // 仅 FK 订单场景走订单模式：mandate 授权回跳 URL 携带的 outTradeNo 是 mandate charge
      // 商户单号（非业务订单号），YJ 若误用会以 ORDER_PAY 查无此单失败，故按 savedType 判定
      if (outTradeNo && savedType !== "YJ") {
        // 订单模式（FK 房费/欠费）：授权回调 URL 携带业务订单号
        datas = {
          bizScene: "ORDER_PAY",
          orderPaySubType: "PAY_ORDER",
          outTradeNo: outTradeNo,
          dva: true
        }
      } else {
        // 充值模式（YJ 押金/CZ 余额）：金额取 URL 回传参数（优先）或 confirm 页外跳前存值（兜底）；
        // 两处均丢失时不再发必败请求，给出明确提示便于排查
        if (!savedAmount) {
          console.warn("[DVA] startPay: amount missing", {
            query: q,
            isRetry: !!isRetry,
            hasAmount: !!localStorage.getItem("cdb_dva_pay_amount"),
            hasRetryAmount: !!localStorage.getItem("cdb_dva_retry_amount"),
            hasType: !!localStorage.getItem("cdb_dva_pay_type")
          })
          this.stopTimer()
          this.loading = false
          this.error = "Payment session expired, please retry from the cabinet"
          return
        }
        // 与 confirm.vue _onMandateActive() 严格对齐：YJ 补差需 rechargeType + qrcode。
        // 取 "balance"（非 "deposit"）：payOrderByDva 据此 paytype=1 → addBalance() 写 P_BALANCE，
        // 而 useBalanceToRent 只读 P_BALANCE；deposit 会写 P_DEPOSIT_AMOUNT 致租借接口判余额不足、
        // 返回 needRechargeAmount 且无 outTradNo，最终弹 "Request failed"。弹宝由本页 onBorrow 主动发起
        datas = {
          bizScene: "RECHARGE",
          rechargeSubType: "WALLET",
          amount: String(savedAmount),
          dva: true
        }
        if (savedType === "YJ") {
          datas.rechargeType = "balance"
          if (savedQrcode) {
            datas.qrcode = savedQrcode
          }
        }
      }
      console.log("[DVA] startPay v2 下单请求:", JSON.stringify(datas))
      this.$postV2(
        STRIPE_V2_RECHARGE,
        datas,
        (resp) => {
          const v2Data = resp.data || {}
          console.log("[DVA] startPay v2 下单响应:", v2Data)
          if (v2Data.outTradeNo && v2Data.status !== "FAILED") {
            // 支付已受理，清理外跳前持久化的金额/类型/cabinetID/会话标记
            localStorage.removeItem("cdb_dva_pay_amount")
            localStorage.removeItem("cdb_dva_pay_type")
            localStorage.removeItem("cdb_borrow_cabinet_id")
            localStorage.removeItem("cdb_dva_session")
            localStorage.removeItem("cdb_dva_retry_amount")
            localStorage.removeItem("cdb_dva_retry_type")
            localStorage.removeItem("cdb_dva_retry_order")
            // 重建重试快照：本单后续失败时 onReload 需凭它重新下单（金额/类型/业务订单号）
            localStorage.setItem("cdb_dva_session", "1")
            localStorage.setItem("cdb_dva_retry_amount", String(savedAmount || ""))
            if (datas.bizScene === "ORDER_PAY") {
              localStorage.setItem("cdb_dva_retry_type", "ORDER")
              localStorage.setItem("cdb_dva_retry_order", outTradeNo)
            } else {
              localStorage.setItem("cdb_dva_retry_type", savedType || "")
            }
            this.outTradeNo = v2Data.outTradeNo
            this.$store.commit('payType', savedType)
            // URL 规范化：mandate 回跳场景的 dvaMandate=1 会一直留在地址栏，用户刷新一次即
            // 重新执行 created → 再下一单（重复扣款）；改写为已受理形态后刷新仅轮询本单
            this.$router.replace(`/result?outTradeNo=${v2Data.outTradeNo}&payType=PayStack&dvaPaid=1`)
            // 复用普通 PayStack 确认链路：v2 sync 轮询 → SUCCESS → 按 payType 分派
            this.onPayStackConfirm(v2Data.outTradeNo)
          } else {
            this.stopTimer()
            this.loading = false
            this.error = (v2Data && v2Data.errorMsg) || this.i18n.msg_pay_failed
          }
        },
        (error) => {
          this.stopTimer()
          this.loading = false
          this.error = error
          console.error("DVA start pay error:", error)
        }
      )
    }
  },
  created() {
    console.log("[DVA] result created:", this.$route.query, "| ls:", {
      amount: localStorage.getItem("cdb_dva_pay_amount"),
      type: localStorage.getItem("cdb_dva_pay_type"),
      session: localStorage.getItem("cdb_dva_session"),
      retryAmount: localStorage.getItem("cdb_dva_retry_amount"),
      cabinetId: localStorage.getItem("cdb_borrow_cabinet_id")
    })
    let {
      paymentId,
      outTradeNo,
      type,
      token,
      PayerID,
      tradeNo,
      payMode,
      payType,
      cabinetID,
      reference
    } = this.$route.query
    this.payMode = payMode
    console.log("-------" + payType)
    // 若因之前的 result 页 destroyed 钩子导致 store 中 cabinet 丢失，
    // 先从路由 query 或独立 localStorage key 恢复到 store
    // （dvaQrcode 为后端 mandate 回调回显项：移动端跨站跳转会清 localStorage，须以 URL 为优先来源）
    const savedBorrowId = localStorage.getItem("cdb_borrow_cabinet_id") || this.$route.query.dvaQrcode || ""
    if (!this.cabinet && (cabinetID || savedBorrowId)) {
      this.$store.commit("cabinet", { cabinetID: cabinetID || savedBorrowId })
    }
    if (!!outTradeNo & !!type) {
      this.onMyfatoorahConfirm(tradeNo, outTradeNo, type)
    } else if (tradeNo) {
      this.checkOrder(tradeNo, payMode, payType)
    } else if (payType === 'PayStack') {
      // DVA 分支判定只认 URL 显式标记，不再把 localStorage 残留金额当作「待下单」信号：
      //   dvaMandate=1 → mandate 授权回跳，真实金额尚未扣款，必须发起 v2 下单
      //                  （否则会把 mandate charge 交易号当订单确认，₦100 同步成功后直接建租借）
      //   dvaPaid=1    → confirm 页直扣已受理，与普通 PayStack 同链路只做 sync 轮询
      // 旧实现的 `|| !!localStorage.getItem("cdb_dva_pay_amount")` 在历史残留时会把已受理单
      // 重新下一笔，造成 PayStack 重复扣款且首笔永不落账
      const isMandateReturn = this.$route.query.dvaMandate === '1'
      if (isMandateReturn) {
        // mandate 授权回跳：先轮询 mandate 状态确认 ACTIVE，再发起扣款
        this._dvaPollMandate()
      } else {
        this.outTradeNo = outTradeNo
        // 普通 PayStack 回跳 / DVA 已受理单：业务类型需靠持久化恢复；
        // store 整页刷新丢失时从 pay_type（或重试快照 retry_type）兜底，避免 SUCCESS 后无法分派跳转
        if (!this.payType) {
          const savedType = localStorage.getItem("cdb_dva_pay_type") || localStorage.getItem("cdb_dva_retry_type")
          // ORDER 是订单会话标记而非 payType 取值，不得写入 store
          if (savedType && savedType !== "ORDER") {
            this.$store.commit("payType", savedType)
          }
          localStorage.removeItem("cdb_dva_pay_type")
          localStorage.removeItem("cdb_dva_pay_amount")
        }
        this.onPayStackConfirm(outTradeNo)
      }
    } else if (payType === 'PayStack_DVA') {
      // PayStack DVA mandate 授权回跳：先轮询 mandate 状态确认 ACTIVE，再发起 v2 DVA 下单
      this._dvaPollMandate()
    } else {
      this.paypal = {
        paymentId,
        token,
        payerId: PayerID
      }
    }
  },
  destroyed() {
    this.$store.commit("cabinet", null)
  }
}
</script>

<style lang="less">
.result-content {
  min-height: 100vh;
  // background: #fff;

  .unlocked {
    max-width: 30%;
    display: block;
    margin: 0px auto;
    padding: 50px 0 0;
  }

  h2 {
    font-size: 52px;
    // 对齐 App 强调字体 Montserrat-M
    font-family: @font-medium;
    font-weight: bold;
    text-align: center;
    margin: 0;
    padding: 80px 0 40px;
  }

  .mainbanner {
    max-width: 50%;
    display: block;
    margin: 6vh auto;
  }

  .tips {
    font-size: 28px;
    // color: #666666;
    text-align: center;
    margin: 20px 40px 40px;
  }

  .downloadbtn {
    width: 80%;
    margin: 0 auto;
    // 对齐 App 主按钮字体，淘汰 DIN
    font-family: @font-medium;
    font-size: 42px;
    font-weight: bold;
    border-radius: @radius-btn;

    span {
      display: block;
    }
  }

  // Back to Map 次级按钮：白底描边，覆盖 .btn 主题色
  .downloadbtn.mapbtn {
    margin-top: 24px;
    background: #fff;
    border: 2px solid var(--text-main);
    color: var(--text-main);
  }
}

.result-loading {
  &.circle {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &-warp {
    background: #ffffff;
    padding: 30px 0;
  }

  & span {
    position: absolute;
    font-size: 70px;
    // 对齐 App result：倒计时数字黑色（textColor）
    color: var(--text-main);
  }

  &-tips {
    text-align: center;
    font-size: 28px;
    color: var(--text-sub);
  }
}
</style>
